import { Spin, type SpinProps } from 'antd';
import type React from 'react';

type SpinSize = NonNullable<SpinProps['size']>;

interface CenteredSpinProps {
  style?: React.CSSProperties;
  size?: SpinSize;
}

export const CenteredSpin: React.FC<CenteredSpinProps> = ({ style, size = 'default' }) => {
  return (
    <div className="centered-spinner" style={style} data-testid="centered-spinner-container">
      <Spin size={size} />
    </div>
  );
};
